import { useMemo } from 'react';
import { Avatar } from 'antd';
import shopSelectors from 'services/shop/selectors';
import styled from 'styled-components';
import userSelectors from 'features/user/services/selectors';
import { STAFF_TYPE } from 'features/cashier/services/types/constant';

const ManagementTeamView = () => {
  const globalConfig = shopSelectors.data.allSetting();
  const listAvailableWorking = userSelectors.listAvailableWorking();
  const staffs = useMemo(() => listAvailableWorking.filter(o => o.staffType === STAFF_TYPE.CASHIER), [listAvailableWorking]) || [];
  if (!globalConfig?.displayCashierClockIn || staffs?.length === 0) return null;

  return (
    // <Layout.Sider
    //   translate="no"
    //   reverseArrow
    //   width={152}
    //   collapsedWidth={0}
    //   className="ant-content-overflow sider"
    // >
    //   <HeaderCountLengthButton>
    //     <CountLengthButton>
    //       <HeaderManagementTeamText>Cashier</HeaderManagementTeamText>
    //       <CountLengthTeam>{staffs?.length || 0}</CountLengthTeam>
    //     </CountLengthButton>
    //   </HeaderCountLengthButton>


    // </Layout.Sider>
    <Container>
      {staffs.map((o) => (
        <ItemContainer key={o.staffId}>
          <ItemAvatar>
            <Avatar size={48} src={o.staffAvatar} style={{ backgroundColor: 'rgb(245 106 0 / 30%)', border: '1px solid #f56a00' }}>
              {o.staffName?.charAt(0).toUpperCase()}
            </Avatar>
          </ItemAvatar>

          <ItemContent>
            <ItemName>{o.staffName}</ItemName>
            <ItemTime>C: {o.timeClockIn}</ItemTime>
          </ItemContent>
        </ItemContainer>
      ))}
    </Container>
  );
};

export default ManagementTeamView;

const Container = styled.div`
  height: 100%;
  overflow: auto;
  padding: 0 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: 660px;
`;

const ItemContainer = styled.div`
  display: flex;
  width: 100px;
  min-width: 100px;
  padding: 4px 8px;
  flex-direction: column;
  align-items: center;
  gap: 0;
  border-radius: 8px;
  border: 1px solid #ccd4dc;
  background: #fff;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15);
`;

const ItemAvatar = styled.div`
  display: flex;
  height: 48px;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`;

const ItemContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  align-self: stretch;
`;

const ItemName = styled.div`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  align-self: stretch;
  overflow: hidden;
  color: #1d2129;
  text-align: center;
  text-overflow: ellipsis;

  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  text-transform: uppercase;
`;

const ItemTime = styled.div`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  color: var(--Text-03, #64748b);
  text-align: center;
  text-overflow: ellipsis;

  /* Body/Body 1 - 14 medium */
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

const CountLengthTeam = styled.div`
  color: #1D2129;
  font-family: Poppins;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px; /* 100% */
`;

const HeaderManagementTeamText = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1D2129;
  font-family: Poppins;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

const HeaderCountLengthButton = styled.div`
  padding: 0 16px;
  border-right: 1px solid #CCD4DC;
`;

const CountLengthButton = styled.div`
  cursor: pointer;
  display: flex;
  padding: 0 8px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  border-radius: 8px;
  background: #fff;
  border: 1px solid #CCD4DC;
  box-sizing: border-box;
  height: 64px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15);
`;